module.exports = __webpack_public_path__ + "static/media/rollerblade2.bf0d0467.gif";